import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { PublicPclProduct } from "api/public/project/product/product.types";

const StatusCell = ({
  row: { status_sort: status },
}: {
  row: PublicPclProduct;
}) => {
  const isArchived = status === "Archived";
  const isCertified = status === "Certified";

  let statusText = status;
  let color = "yellow";

  if (isCertified) {
    color = "green";
  } else if (isArchived) {
    color = "orange";
  }

  return (
    <>
      <FontAwesomeIcon
        icon={faCircle}
        className="me-1"
        color={`var(--bs-${color})`}
        size="xs"
      />
      <span
        style={{
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
      >
        {statusText}
      </span>
    </>
  );
};

export default StatusCell;
